export default "__VITE_ASSET__a5418f71__"